import React, { useState } from 'react';
import { Card, Typography, Row, Col } from 'antd';
import LoginForm from './LoginForm';
import firLogo from '../../assets/fir_logo.png';

const { Title } = Typography;

const AuthPage: React.FC = () => {
  const [isLogin, setIsLogin] = useState(true);

  return (
    <Row justify="center" align="middle" style={{ minHeight: 'calc(100vh - 64px)', padding: '20px' }}> {/* Adjust minHeight if header height changes */}
      <Col xs={24} sm={16} md={12} lg={8} xl={6}>
        <Card>
          <div style={{ textAlign: 'center', marginBottom: '24px' }}>
            <img src={firLogo} alt="FIR Logo" style={{ height: '50px', marginBottom: '10px' }} />
            <Title level={3}>PBA – Pfisterer BOM Analyzer</Title>
          </div>
          <LoginForm onSwitchToSignup={() => setIsLogin(false)} />
        </Card>
      </Col>
    </Row>
  );
};

export default AuthPage;